export const css = {
	welcome: '_2fR5BWpF',
	skip: 'a3K6r-FT',
	' _key': 'ascm-theme/ascm/landing-page/welcome-view'
};

export default css;
